import React, { useState, useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
} from '@mui/material';

import { formatDate, formatHumanTime, dummyData } from "./helpers";
import useSortHead from './useSortHead';
import { useAppState } from './AppStateContext';

const Students = () => {
    const { apiGet } = useAppState();

    const { TableCellSortHead, sortFunction } = useSortHead();
    const [students, setStudents] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchStudents = async () => {
        try {
            const response = await apiGet('students');
            setStudents(response.data);
            setIsLoading(false);
        } catch (err) {
            setError('An error occurred while trying to load the students.');
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchStudents();
    }, []);

    let dummyIndex = 0;
    const sortedStudents = students.map((student, index) => {
        if (student.email.endsWith('@dummyschool.edu')) {
            const dummy = dummyData[dummyIndex % 32];
            dummyIndex++;
            student = {...student, ...dummy};
        }

        const numClasses = student.classes.length;
        const className = numClasses > 0 ?
            student.classes[0].name + (numClasses > 1 ? (` +${numClasses - 1}`) : '')
            : "";

        const last_active_sortkey = student.last_active_at === null ? '0000-00-00' : student.last_active_at;
        return {...student, last_active_sortkey, className};
    }).sort(sortFunction);

    return (
        <div>
            <h1>Students</h1>
            <p>Here you’ll find all your students, past and present.</p>

            <TableContainer>
              {isLoading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
                    <CircularProgress />
                  </div>
              ) : error ? (
                  <p style={{ color: 'red', padding: '20px' }}>{error}</p>
              ) : (
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCellSortHead field='name'>Student</TableCellSortHead>
                            <TableCellSortHead field='className'>Class</TableCellSortHead>
                            <TableCellSortHead field='last_active_sortkey'>Last active</TableCellSortHead>
                            <TableCellSortHead field='total_time'>Total input time</TableCellSortHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {sortedStudents.map(student => {
                            return (
                                <TableRow
                                    key={student.email}
                                >
                                    <TableCell onClick={() => null}>{student.name || student.email}</TableCell>
                                    <TableCell>{student.className}</TableCell>
                                    <TableCell>{formatDate(student.last_active_at)}</TableCell>
                                    <TableCell>{formatHumanTime(student.total_time)}</TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
              )}
            </TableContainer>
        </div>
    );
};

export default Students;
